import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./HomePage.css";

const navItems = [
  { label: "Home", path: "/" },
  { label: "Products", path: "/products" },
  { label: "Login", path: "/login" },
  { label: "Register", path: "/register" },
];

const roleCards = [
  {
    title: "Buyers",
    description: "Browse products, compare prices, and place orders quickly.",
  },
  {
    title: "Sellers",
    description: "Manage listings, pricing, stock, and incoming orders.",
  },
  {
    title: "Admins",
    description: "Oversee users, products, and the overall platform flow.",
  },
];

export default function HomePage() {
  const navigate = useNavigate();
  const location = useLocation();

  const goToLogin = () => {
    navigate("/login", { state: { skipSessionCheck: true } });
  };

  useEffect(() => {
    document.title = "Balitah - Local Bruneian E-commerce Platform";

    let descriptionTag = document.querySelector('meta[name="description"]');
    if (!descriptionTag) {
      descriptionTag = document.createElement("meta");
      descriptionTag.setAttribute("name", "description");
      document.head.appendChild(descriptionTag);
    }

    descriptionTag.setAttribute(
      "content",
      "Balitah is a local Bruneian e-commerce platform for buyers, sellers, and admins.",
    );
  }, []);

  return (
    <div className="home-page">
      <header className="wf-nav home-nav">
        <button
          type="button"
          className="wf-brand"
          onClick={() => navigate("/")}
        >
          <img
            src="/favicon-48-white.png"
            alt="Balitah logo"
            className="wf-brand-logo"
          />
          BALITAH
        </button>

        <div className="home-nav-spacer" aria-hidden="true" />

        <nav
          className="wf-nav-actions home-links"
          aria-label="Primary navigation"
        >
          {navItems.map((item) => {
            const isActive =
              item.path === "/"
                ? location.pathname === "/"
                : location.pathname === item.path ||
                  location.pathname.startsWith(`${item.path}/`);

            return (
              <button
                key={item.path}
                type="button"
                className={`wf-btn${isActive ? " wf-btn--active" : ""}`}
                onClick={() => {
                  if (item.path === "/login") {
                    goToLogin();
                    return;
                  }

                  navigate(item.path);
                }}
              >
                {item.label}
              </button>
            );
          })}
        </nav>
      </header>

      <main>
        <section className="home-hero">
          <div className="home-hero-copy">
            <p className="home-eyebrow">Local Bruneian e-commerce platform</p>
            <h1>BALITAH</h1>
            <p className="home-subtitle">
              Local Bruneian e-commerce platform for buyers, sellers and admins.
            </p>
            <p className="home-description">
              Balitah is a MERN-based e-commerce platform where buyers can
              browse local Bruneian products, sellers can manage listings, and
              admins oversee the system.
            </p>

            <div className="home-actions">
              <button
                type="button"
                className="home-button home-button-primary"
                onClick={() => navigate("/products")}
              >
                Browse Products
              </button>
              <button
                type="button"
                className="home-button home-button-secondary"
                onClick={goToLogin}
              >
                Login
              </button>
            </div>
          </div>

          <div className="home-hero-panel">
            <div className="home-panel-card">
              <span className="home-panel-label">Quick start</span>
              <h2>What can I do here?</h2>
              <ul>
                <li>Browse and search local Bruneian products.</li>
                <li>Create an account to buy or sell.</li>
                <li>Track orders from your dashboard.</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="home-section home-roles-section">
          <div className="home-section-header">
            <h2>How Balitah Works</h2>
            <p>Clear roles keep the platform simple for everyone.</p>
          </div>

          <div className="home-roles-grid">
            {roleCards.map((role) => (
              <article key={role.title} className="home-role-card">
                <h3>{role.title}</h3>
                <p>{role.description}</p>
              </article>
            ))}
          </div>
        </section>
      </main>

      <footer className="home-footer">© 2026 Balitah</footer>
    </div>
  );
}
